import React from "react";
import { FlatButton, RaisedButton, TextField, ListItem } from "material-ui";
import { colors as Colors } from "material-ui/styles";

import * as util from "../../util";

import List from "./list/list.jsx";
import BaseOverlay from "../overlays/base.jsx";
import SupplementaryDataEditor from "./supplementary-data-editor.jsx";

import PersonStore from "../../stores/PersonStore";

class SupplementaryDataCheckoutEntry extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      names: [],
      supplementary_datas: []
    };

    this._update = this._update.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object
  };

  componentDidMount() {}

  _update() {
    const idx = this.props.order.subitems.findIndex(
      i => i.pass_bucket === this.props.pass.id
    );
    let subitems = this.props.order.subitems.slice();
    subitems[idx].names = this.state.names;
    subitems[idx].supplementary_datas = this.state.supplementary_datas;
    this.props.updateCurrentOrder({
      subitems: subitems
    });
    this.props.order;
  }

  _updatePass(idx, supplementary_data) {
    // Extract name from payload
    const name = supplementary_data.name;
    delete supplementary_data.name;

    const names = this.state.names.slice();
    while (names.length <= idx) {
      names.push(null);
    }
    names[idx] = name;

    const supplementary_datas = this.state.supplementary_datas.slice();
    while (supplementary_datas.length <= idx) {
      supplementary_datas.push(null);
    }
    supplementary_datas[idx] = supplementary_data;

    this.setState({ names, supplementary_datas });
  }

  generatePayload(idx) {
    const name = this.state.names[idx] || "";
    const data = Object.assign({}, this.state.supplementary_datas[idx]);
    data.name = name;

    const neededData = this.props.pass.supplementary_data.slice();
    const nameRequired = !this.context.tenant.sundance_login;

    if (nameRequired) {
      neededData.splice(0, 0, {
        key: "name",
        required: true,
        label: `Full name to display on ${this.context.tenant.display_pass}`
      });
    }

    const payload = {
      name,
      supplementary_data: data,

      needs_supplementary_data:
        this.props.pass.supplementary_data &&
        (!this.props.pass.supplementary_data.every(d => {
          return !d.required || data[d.key];
        }) ||
          (nameRequired && !name)),

      pass_bucket: this.props.pass,
      needed_supplementary_data: neededData,

      onChange: data => {
        this._updatePass(idx, data);
      }
    };

    return payload;
  }

  getStyles() {
    return {
      container: {
        maxWidth: 400,
        textAlign: "center",
        margin: "0 auto"
      },
      actions: {
        marginTop: "1.5em"
      },
      listing: {
        border: "1px solid #ccc",
        marginBottom: "1em",
        textAlign: "left"
      }
    };
  }

  render() {
    let styles = this.getStyles();

    const subitem = this.props.order.subitems.find(
      i => i.pass_bucket === this.props.pass.id
    );
    const quantity = subitem.quantity;

    const payloads = new Array(quantity)
      .fill(null)
      .map((_, idx) => this.generatePayload(idx));

    const ready = payloads.every(p => !p.needs_supplementary_data);

    return (
      <div style={styles.container}>
        <div style={styles.listing}>
          <List
            items={payloads}
            timeGetter={i => 0}
            ListItem={SupplementaryDataListItem}
            dontBreakIntoSections={true}
            hideDateHeaders={true}
            hidePastHeader={true}
            hideActions={true}
          />
        </div>

        <div style={styles.actions}>
          <RaisedButton
            label={`Confirm ${this.context.tenant.display_pass} details`}
            disabled={!ready}
            primary={true}
            onClick={this._update}
          />
        </div>
      </div>
    );
  }
}

class SupplementaryDataListItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      supplementaryDataDialogOpen: false,
      enteredData: {}
    };
    this.editSupplementaryData = this.editSupplementaryData.bind(this);
  }

  static contextTypes = {
    tenant: React.PropTypes.object
  };

  editSupplementaryData() {
    this.setState({ supplementaryDataDialogOpen: true });
  }

  getStyles() {
    return {
      editLink: {
        fontSize: 13,
        color: "rgba(0, 0, 0, 0.54)",
        textDecoration: "underline",
        cursor: "pointer"
      },
      dataNeeded: {
        color: "#fff",
        fontSize: 13,
        backgroundColor: Colors.red600,
        cursor: "pointer",
        padding: "0 2px"
      }
    };
  }

  componentWillReceiveProps(newProps) {
    this.setState({ enteredData: newProps.item.supplementary_data });
  }

  componentDidMount() {
    this.componentWillReceiveProps(this.props);
  }

  render() {
    const {
      name,
      supplementary_data,
      needs_supplementary_data,
      needed_supplementary_data,
      pass_bucket,
      onChange
    } = this.props.item;
    const styles = this.getStyles();

    const nameRequired = !this.context.tenant.sundance_login;

    return (
      <div>
        <BaseOverlay
          zIndex={2001}
          useMuiDefaultStyle={true}
          title={`${util.capitalize(
            this.context.tenant.display_pass
          )} information`}
          open={this.state.supplementaryDataDialogOpen}
          actions={[
            <FlatButton
              label="Cancel"
              onClick={() =>
                this.setState({ supplementaryDataDialogOpen: false })
              }
            />,
            <FlatButton
              label="Submit"
              onClick={() => {
                onChange(this.state.enteredData);
                this.setState({ supplementaryDataDialogOpen: false });
              }}
            />
          ]}
          onRequestClose={() =>
            this.setState({ supplementaryDataDialogOpen: false })
          }
        >
          <SupplementaryDataEditor
            fields={needed_supplementary_data}
            data={this.state.enteredData}
            existingImages={
              (PersonStore.getPersonDetails() || {}).supplementary_data_images
            }
            updateDataValue={(key, value) => {
              this.setState({
                enteredData: Object.assign({}, this.state.enteredData, {
                  [key]: value
                })
              });
            }}
          />
        </BaseOverlay>
        <ListItem
          secondaryText={<p>{pass_bucket.name}</p>}
          secondaryTextLines={1}
          disabled={true}
          style={{}}
          primaryText={
            <div>
              {!nameRequired
                ? "New Pass"
                : !name
                ? `Unnamed ${util.capitalize(this.context.tenant.display_pass)}`
                : name}{" "}
              <a style={styles.editLink} onClick={this.editSupplementaryData}>
                edit details
              </a>
              &nbsp;
              {needs_supplementary_data ? (
                <a
                  onClick={this.editSupplementaryData}
                  style={styles.dataNeeded}
                >
                  details needed!
                </a>
              ) : null}
            </div>
          }
        />
      </div>
    );
  }
}

export default SupplementaryDataCheckoutEntry;



// WEBPACK FOOTER //
// ./src/app/components/partials/supplementary-data-checkout-entry.jsx